import React from 'react';
import BuyButtonContainer from "../Containers/BuyButton.container";
import {translate} from "../Services/translation";

/**
 * Basically does the same as `Src/Litium.Accelerator.Mvc/Extensions/ProductItemViewModelHtmlExtensions.cs`
 *
 * @param productItem
 * @param articleNumber
 * @param cssClass
 * @param isBuyOnline
 * @returns {JSX.Element}
 * @constructor
 */
const BuyButtonWrapper = function ({
    productItem,
    isProductPage,
    cssClass = '',
    isBuyOnline = null,
    noneFoundClass = '',
    labelAndIcon = null,
    openMiniCartAtCheckout = true
}) {
    if (typeof productItem === 'undefined') return null;

    let isBuyableProduct = productItem.isBuyable && isBuyOnline === false;
    let canBuyOnline = productItem.showBuyButton && ((isBuyOnline !== null && isBuyOnline) || productItem.useVariantUrl) && productItem.isInStock;
    let label = isProductPage ? isBuyableProduct
        ? (productItem.isInStock ? translate('buybutton') : translate('isoutofstock'))
        : (canBuyOnline || (isBuyOnline !== null && isBuyOnline) ? translate('buyorproductsonlineheader') : "product.show") : null;

    if (labelAndIcon !== null) {
        label = labelAndIcon.label;
    }

    let href = '#';
    let quantityFieldId = '';

    cssClass = `button ${canBuyOnline || (isBuyOnline !== null && isBuyOnline) ? "buy-button" : "show-button"} ${cssClass} ${isProductPage ? "" : "muurikka-btn--red quick-buy-button"}`.trim();
    cssClass += ` ${noneFoundClass}`;

    let enabled = !(!productItem.url || !productItem.price.hasPrice || !productItem.isInStock || !isBuyableProduct);
    let articleNumber = enabled && (canBuyOnline || isBuyableProduct) ? productItem.id : '';

    if (canBuyOnline || isBuyableProduct) {
        if (enabled) {
            quantityFieldId = productItem.showQuantityField ? productItem.quantityFieldId : '';
        } else {
            cssClass += " disabled";
        }
    } else {
        if (isBuyOnline !== null && isBuyOnline) {
            cssClass += " disabled";
        }
    }

    let trackingProduct = productItem.trackingProduct;
    let newProps = { label, articleNumber, quantityFieldId, href, cssClass, labelAndIcon, trackingProduct, openMiniCartAtCheckout };
    return <BuyButtonContainer {...newProps} />
}

export default BuyButtonWrapper;
